import { createDomain } from 'effector'

export const domain = createDomain('processes/auth')
